export enum GridColumnPropName {
  MaxWidth = 'maxWidth',
  MinWidth = 'minWidth',
  Width = 'width',
}
